import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';
import { ShoppingBag, RateReview } from '@mui/icons-material';
import { Product } from '../types';
import RatingDisplay from './RatingDisplay';

interface ProductCardProps {
  product: Product;
  onViewReviews: (product: Product) => void;
  onAddReview: (product: Product) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  onViewReviews,
  onAddReview,
}) => {
  const totalReviews = product.rating_stats
    ? Object.values(product.rating_stats).reduce((sum, count) => sum + count, 0)
    : 0;

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4,
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <ShoppingBag color="primary" />
          <Typography variant="h6" component="h3">
            {product.name}
          </Typography>
        </Box>

        {product.description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2, height: 40, overflow: 'hidden' }}
          >
            {product.description}
          </Typography>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" color="primary.main" fontWeight="bold">
            {product.price.toLocaleString('ru-RU', {
              style: 'currency',
              currency: 'RUB',
            })}
          </Typography>
          <Chip
            label={`${totalReviews} отзывов`}
            size="small"
            variant="outlined"
            color="primary"
          />
        </Box>

        {product.average_rating !== undefined && totalReviews > 0 && (
          <RatingDisplay
            rating={product.average_rating}
            reviewCount={totalReviews}
            size="small"
          />
        )}
      </CardContent>

      <CardActions sx={{ justifyContent: 'space-between', p: 2 }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<RateReview />}
          onClick={() => onViewReviews(product)}
        >
          Отзывы
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => onAddReview(product)}
        >
          Написать отзыв
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;


